const qs = document.querySelector.bind(document);
const qsA = document.querySelectorAll.bind(document);

const reducedMotion = window.matchMedia('(prefers-reduced-motion)');
if(!reducedMotion.matches) {
  qsA('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const hash = this.getAttribute('href');
      history.pushState(null, null, hash);
      qs(hash).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      });
    });
  });
}
